var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenueAudit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3F41D1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 12.5,
    x: 2.75,
    y: 3.25,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21.25h8M12 15.75v5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.75 9.75l2.25 2.25l4.25-4.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenueAudit);
export default __webpack_public_path__ + "static/media/venue-audit.012e1d879b6b29478b13cc9698899449.svg";
export { ForwardRef as ReactComponent };